import React, { useEffect, useRef, useState } from 'react';
import { ResumePreview } from '../ResumePreview';
import { SAMPLE_SECTIONS } from '../../lib/sampleResume';

// Renders a real template preview scaled to its container width (A4 = 794px wide).
export const ResumeThumb = ({ templateId, accent, sections = SAMPLE_SECTIONS, india = false, className = '', maxHeight }) => {
  const ref = useRef(null);
  const [scale, setScale] = useState(0.4);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const update = () => setScale(el.clientWidth / 794);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} className={`relative w-full overflow-hidden bg-white ${className}`} style={{ aspectRatio: maxHeight ? undefined : '794 / 1123', height: maxHeight }} aria-hidden="true">
      <div className="pointer-events-none absolute left-0 top-0 origin-top-left" style={{ width: 794, transform: `scale(${scale})` }}>
        <ResumePreview resume={{ template_id: templateId, theme_color: accent, sections, india_fields: { enabled: india } }} />
      </div>
    </div>
  );
};
